import React from 'react';
import PropTypes from 'prop-types';
import FilterBySelectInput from 'components/FilterBySelectInput';

const ProductListTypeFilter = ({
  width = '100%',
  typeFilters,
  handleFilterChange,
  typeFilterOptions
}) => (
  <div className="font-medium h-8 whitespace-nowrap" style={{ width }}>
    <FilterBySelectInput
      selectDataTestId="product-type-filter"
      options={typeFilterOptions}
      value={typeFilters}
      onChange={handleFilterChange}
      placeholder="Filter by type"
    />
  </div>
);

ProductListTypeFilter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  typeFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  typeFilterOptions: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  handleFilterChange: PropTypes.func.isRequired
};
export default ProductListTypeFilter;
